import React from 'react';
import Container from './Container';
import Button from './Buttons';
import BoardRoomImage from '../images/holborn-board-room.webp'; 

const AboutCta = () => {
    return (
        <section className="py-24 bg-holborn-light-grey">
            <Container>
                <div className="grid grid-cols-1 lg:grid-cols-2 items-stretch gap-0 rounded-3xl overflow-hidden shadow-xl">
                    
                    <div 
                        className="w-full bg-cover bg-center min-h-[350px] lg:min-h-0 rounded-t-3xl lg:rounded-l-3xl lg:rounded-tr-none"
                        style={{ 
                            backgroundImage: `url(${BoardRoomImage})`, 
                        }}
                    >
                        <span className="sr-only">Holborn board members in a meeting room</span>
                    </div>
                    <div className="w-full bg-white py-20 lg:py-32 px-12 lg:px-20 rounded-b-3xl lg:rounded-r-3xl lg:rounded-bl-none">
                        <h2 className="text-3xl lg:text-4xl font-extrabold mb-4 text-holborn-blue">
                            What makes Holborn, Holborn
                        </h2>
                        <p className="text-holborn-mid-blue mb-8">
                            We believe in building long-term relationships based on trust, transparency, and exceptional service. Our team of experts is dedicated to understanding your unique financial goals and crafting personalized strategies to help you achieve them. Discover the Holborn difference and take the first step towards a brighter financial future with us.
                        </p>
                        <Button 
                            to="/about/" 
                            variant="blue" 
                            className="w-auto"
                        >
                            Read about us
                        </Button>
                    </div>

                </div>
            </Container>
        </section>
    );
};

export default AboutCta;